import React, { PureComponent } from "react";
import Slider from "react-slick";

import {
  TTP_HOME_URL,
  TTP_BLOG_URL,
  TTP_FFF_BLOG,
  TTP_DEG_BLOG,
  TTP_BE_ACCOUNTANTS_BLOG,
  LAYOUT_DISPOSITIONS
} from "Config";
import ArticleContainer from "../Article/ArticleContainer";
import FetchingArticlesList from "../Fetching/FetchingArticlesList";
import { slugify } from "Utils";

import _ from "i18n";

export default class ArticlesListComponent extends PureComponent {
  renderArticles() {
    const { community, fetching, fetched, articles, disposition } = this.props;

    if (fetching) {
      return <FetchingArticlesList />;
    }
    if (!fetched || !articles || articles.length === 0) {
      return null;
    }

    let helpBlocTypes = [];
    let counter = 0;
    for (let disp of disposition) {
      if (counter >= articles.length) {
        break;
      }
      counter += LAYOUT_DISPOSITIONS.BLOG[disp];
      helpBlocTypes.push(disp);
    }

    let blocs = [];

    let i = 0;
    for (const blocType of helpBlocTypes) {
      let nbArticle = LAYOUT_DISPOSITIONS.BLOG[blocType];
      let blocArticle = [];
      let blocBigArticle = null;

      switch (blocType) {
        case "B1":
          for (let j = i; j < Math.min(articles.length, i + nbArticle); j++) {
            if (i === j) {
              blocBigArticle = (
                <ArticleContainer
                  article={articles[j]}
                  community={community}
                  index={0}
                />
              );
            } else {
              blocArticle.push(
                <div
                  className="cell smal-12 medium-6"
                  key={`article-container-${articles[j].id}`}
                >
                  <ArticleContainer
                    article={articles[j]}
                    community={community}
                    index={1}
                  />
                </div>
              );
            }
          }
          blocs.push(
            <div className="slick-block" key={Math.random()}>
              <div className="grid-x">
                <div className={`small-12 medium-6`}>{blocBigArticle}</div>
                <div className={`small-12 medium-6 grid-x`}>
                  {blocArticle.map(bloc => bloc)}
                </div>
              </div>
            </div>
          );
          break;
        case "B2":
          for (let j = i; j < Math.min(articles.length, i + nbArticle); j++) {
            if (i === j) {
              blocBigArticle = (
                <ArticleContainer
                  article={articles[j]}
                  community={community}
                  index={0}
                />
              );
            } else {
              blocArticle.push(
                <div
                  className="cell smal-12"
                  key={`article-container-${articles[j].id}`}
                >
                  <ArticleContainer
                    article={articles[j]}
                    community={community}
                    index={1}
                  />
                </div>
              );
            }
          }
          blocs.push(
            <div className="slick-block" key={Math.random()}>
              <div className="grid-x">
                <div className={`small-12 medium-9`}>{blocBigArticle}</div>
                <div className={`small-12 medium-3 grid-x`}>
                  {blocArticle.map(bloc => bloc)}
                </div>
              </div>
            </div>
          );
          break;
        case "B3":
          for (let j = i; j < Math.min(articles.length, i + nbArticle); j++) {
            if (j === Math.min(articles.length, i + nbArticle) - 1) {
              blocBigArticle = (
                <ArticleContainer
                  article={articles[j]}
                  community={community}
                  index={0}
                />
              );
            } else {
              blocArticle.push(
                <div
                  className="cell smal-12 medium-6"
                  key={`article-container-${articles[j].id}`}
                >
                  <ArticleContainer
                    article={articles[j]}
                    community={community}
                    index={1}
                  />
                </div>
              );
            }
          }
          blocs.push(
            <div className="slick-block" key={Math.random()}>
              <div className="grid-x">
                <div className={`small-12 medium-6 grid-x`}>
                  {blocArticle.map(bloc => bloc)}
                </div>
                <div className={`small-12 medium-6`}>{blocBigArticle}</div>
              </div>
            </div>
          );
          break;
      }
      i += nbArticle;
    }

    const settings = {
      dots: true,
      dotsClass: "slick-dots",
      infinite: true,
      arrows: false,
      speed: 500,
      autoplay: false
    };

    return (
      <div className="section-content">
        <Slider {...settings}>{blocs}</Slider>
      </div>
    );
  }

  render() {
    const { lng, community, order } = this.props;

    const { hubPreferences } = community;

    let currentBloc = null;
    let title = _("News");
    let subtitle = _("All the news you need");

    if (hubPreferences && hubPreferences.layout_settings) {
      currentBloc = hubPreferences.layout_settings.filter(
        bloc => bloc.order === +order
      );
    }
    if (currentBloc && currentBloc.length > 0) {
      if (
        currentBloc[0][`title${lng.toUpperCase()}`] &&
        currentBloc[0][`title${lng.toUpperCase()}`].length > 0
      ) {
        title = currentBloc[0][`title${lng.toUpperCase()}`];
      }
      if (
        currentBloc[0][`subtitle${lng.toUpperCase()}`] &&
        currentBloc[0][`subtitle${lng.toUpperCase()}`].length > 0
      ) {
        subtitle = currentBloc[0][`subtitle${lng.toUpperCase()}`];
      }
    }

    let comUrl = `${TTP_BLOG_URL}/${lng}/community/${
      community.url ? community.url : slugify(community.name)
    }/${community.id}`;

    let isPrivateBlog = false;

    switch (parseInt(community.id, 10)) {
      case 4:
        comUrl = TTP_DEG_BLOG;
        isPrivateBlog = true;
        break;
      case 8:
        comUrl = TTP_BE_ACCOUNTANTS_BLOG;
        isPrivateBlog = true;
        break;
      case 9:
        comUrl = TTP_FFF_BLOG;
        isPrivateBlog = true;
        break;
      default:
    }

    let writeArticleUrl = `${comUrl}/${lng}/article-form`;

    if (isPrivateBlog) {
      const goto = encodeURIComponent(writeArticleUrl);
      writeArticleUrl = `${TTP_HOME_URL}?gotoWithAuth=${goto}`;
    }

    return (
      <section id="new-community-articles">
        <div className="section-body">
          <div className="section-header">
            <div className="section-title">
              <div className="section-title-head">
                <h2>{title}</h2>
                <a href={comUrl} alt="" className="go-app">
                  {_("Blog")}
                </a>
              </div>
              <p className="section-title-subhead">{subtitle}</p>
            </div>
            <div className="section-btn">
              <a
                href={writeArticleUrl}
                target="_blanc"
                alt=""
                className="btn-action"
              >
                <span>+</span> {_("Write article")}
              </a>
              <a
                href={`${comUrl}/${lng}/`}
                target="_blanc"
                alt=""
                className="btn-see-more"
              >
                {_("See more")}
              </a>
            </div>
          </div>
          {this.renderArticles()}
        </div>
      </section>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/ArticlesList/ArticlesListComponent.js